/**
 * @typedef {Object} UtmParameters
 * @property {string} source
 */

const UTM_COOKIE_NAME = 'utm_params';

/**
 * @type {UtmParameters}
 */
const defaultUtmParams = { source: 'none' };

/**
 * Store utm parameters to cookies
 * @param {UtmParameters} utmParameters
 */
export function storeUtmToCookie(utmParameters) {
  BX.setCookie(UTM_COOKIE_NAME, JSON.stringify(utmParameters), { secure: true });
}

/**
 * @returns {UtmParameters}
 */
export function getUtmParameters() {
  try {
    return {
      ...defaultUtmParams,
      ...JSON.parse(BX.getCookie(UTM_COOKIE_NAME))
    };
  } catch (_) {
    return { ...defaultUtmParams };
  }
}
